/**
 * Utilitários para CPF/CNPJ alfanumérico (IN RFB 2.229/2024).
 *
 * normalizeDoc — remove apenas os separadores da máscara visual (. / - e espaços)
 *                e converte para maiúsculas. NÃO remove letras.
 *
 * Use normalizeDoc em campos CPF/CNPJ antes de enviar para o backend ou
 * comparar comprimentos. Para campos puramente CPF (numérico) o resultado
 * é idêntico ao antigo replace(/[^\d]+/g, '').
 */
export function normalizeDoc(value: string): string {
  if (!value) { return ''; }
  return value.replace(/[^a-zA-Z0-9]+/g, '').toUpperCase();
}



// WEBPACK FOOTER //
// ./src/app/cnpj.utils.ts